(function () {
    var selector = ".js-pdp-product-info-schematic";
    var mountedContainers = new WeakMap();

    function loadLottiePlayer(src) {
        if (window.lottie !== undefined) {
            return Promise.resolve(window.lottie);
        }

        if (window.__pdpProductInfoLottiePromise !== undefined) {
            return window.__pdpProductInfoLottiePromise;
        }

        window.__pdpProductInfoLottiePromise = new Promise(function (
            resolve,
            reject,
        ) {
            var script = document.createElement("script");

            script.async = true;
            script.src = src;

            script.addEventListener("load", function () {
                if (window.lottie === undefined) {
                    reject(new Error("Lottie player did not initialize"));
                    return;
                }

                resolve(window.lottie);
            });

            script.addEventListener("error", function () {
                reject(new Error("Failed to load Lottie player: " + src));
            });

            document.head.appendChild(script);
        });

        return window.__pdpProductInfoLottiePromise;
    }

    function isElementInView(element) {
        var rect = element.getBoundingClientRect();
        var viewportHeight = window.innerHeight || 1;

        return (
            rect.top < viewportHeight * 0.85 &&
            rect.bottom > viewportHeight * 0.25
        );
    }

    function mountSchematicAnimation(animationContainer) {
        if (mountedContainers.has(animationContainer)) {
            return;
        }

        var animationSrc = animationContainer.dataset.animationSrc;
        var playerSrc = animationContainer.dataset.playerSrc;

        if (animationSrc === undefined || playerSrc === undefined) {
            return;
        }

        var schematicFigure = animationContainer.closest(
            ".pdp-product-info__media--schematic",
        );

        if (schematicFigure !== null) {
            schematicFigure.classList.add("is-initialized");
        }

        var reduceMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;
        var animation = null;
        var observer = null;
        var hasStarted = false;
        var isUnmounted = false;
        var visibilityFrame = null;

        function stopVisibilityWatch() {
            if (observer !== null) {
                observer.disconnect();
                observer = null;
            }

            window.removeEventListener("scroll", requestVisibilityCheck);
            window.removeEventListener("resize", requestVisibilityCheck);

            if (visibilityFrame !== null) {
                window.cancelAnimationFrame(visibilityFrame);
                visibilityFrame = null;
            }
        }

        function startAnimation() {
            if (hasStarted || isUnmounted) {
                return;
            }

            hasStarted = true;
            stopVisibilityWatch();

            loadLottiePlayer(playerSrc)
                .then(function (lottie) {
                    if (isUnmounted) {
                        return;
                    }

                    animation = lottie.loadAnimation({
                        autoplay: false,
                        container: animationContainer,
                        loop: false,
                        path: animationSrc,
                        renderer: "svg",
                        rendererSettings: {
                            preserveAspectRatio: "xMidYMid meet",
                        },
                    });

                    animation.addEventListener("DOMLoaded", function () {
                        animationContainer.classList.add("is-loaded");

                        if (reduceMotion) {
                            animation.goToAndStop(0, true);
                            return;
                        }

                        animation.play();
                    });

                    animation.addEventListener("complete", function () {
                        animationContainer.classList.add("has-played");
                    });
                })
                .catch(function (error) {
                    animationContainer.classList.add("is-error");

                    if (schematicFigure !== null) {
                        schematicFigure.classList.remove("is-initialized");
                    }

                    console.warn(
                        "Unable to render product info schematic animation",
                        error,
                    );
                });
        }

        function requestVisibilityCheck() {
            if (visibilityFrame !== null) {
                return;
            }

            visibilityFrame = window.requestAnimationFrame(function () {
                visibilityFrame = null;

                if (isElementInView(animationContainer)) {
                    startAnimation();
                }
            });
        }

        function unmount() {
            isUnmounted = true;
            stopVisibilityWatch();

            if (animation !== null) {
                animation.destroy();
                animation = null;
            }

            if (schematicFigure !== null) {
                schematicFigure.classList.remove("is-initialized");
            }

            mountedContainers.delete(animationContainer);
        }

        mountedContainers.set(animationContainer, unmount);

        if ("IntersectionObserver" in window) {
            observer = new IntersectionObserver(
                function (entries) {
                    if (
                        entries.some(function (entry) {
                            return entry.isIntersecting;
                        })
                    ) {
                        startAnimation();
                    }
                },
                { threshold: 0.35 },
            );

            observer.observe(animationContainer);
        } else {
            startAnimation();
        }

        window.addEventListener("scroll", requestVisibilityCheck, {
            passive: true,
        });
        window.addEventListener("resize", requestVisibilityCheck);
        requestVisibilityCheck();
    }

    function mountExistingAnimations() {
        document.querySelectorAll(selector).forEach(function (container) {
            if (container instanceof HTMLElement) {
                mountSchematicAnimation(container);
            }
        });
    }

    document.addEventListener("shopify:section:load", mountExistingAnimations);
    document.addEventListener("shopify:section:unload", function (event) {
        var section = event.target;

        if (!(section instanceof HTMLElement)) {
            return;
        }

        section.querySelectorAll(selector).forEach(function (container) {
            if (container instanceof HTMLElement) {
                var unmount = mountedContainers.get(container);

                if (unmount !== undefined) {
                    unmount();
                }
            }
        });
    });

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", mountExistingAnimations, {
            once: true,
        });
    } else {
        mountExistingAnimations();
    }
})();
